import * as types from './actionTypes';
// import api from 'api/mock';
import api from '../../../api/';

export function getData(keyword) {
	// body...
	return async(dispatch,getState) =>{
		dispatch({
			type:types.LOADING
		});
		try{
			const results = await api.searchArticles(keyword);
			dispatch({
				type : types.LOADED,
				results
			});
		}
		catch(error){
			console.log(error);
		}
	}
}